import React from "react"
import PropTypes from "prop-types"
import moment from "moment"

import { InputCell } from "app/static/frontend/sheets/components/cells/MantineCells/InputCell"
import { CellWrapper } from "app/static/frontend/sheets/components/cells/MantineCells/CellWrapper"

export interface DateCellProps {
    rowId?: number | string
    columnId?: number | string
    children?: string
    sheetId?: string
    editing?: boolean
    isResourceTable?: boolean
    width?: number
    field?: any
    cellIsEditable?: boolean
    row?: any
}

export const DateCell = ({ rowId, columnId, children, cellIsEditable, sheetId, editing, ...props }: DateCellProps) => {
    const formattingFn = (value) => {
        const result =
            value !== null && value !== undefined
                ? moment(Number(value) ? moment.unix(value) : moment(value))
                      .local()
                      .format("L")
                : undefined
        return result
    }
    if (editing && cellIsEditable) {
        return (
            <InputCell
                type="date"
                columnId={columnId}
                isResourceTable={props.isResourceTable}
                rowId={rowId}
                sheetId={sheetId}
                width={props.width}
                field={props.field}
                row={props.row}
                formattingFn={formattingFn}
            >
                {formattingFn(children)}
            </InputCell>
        )
    }
    return (
        <CellWrapper {...props} formattingFn={formattingFn}>
            {formattingFn(children)}
        </CellWrapper>
    )
}
